import { inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subscriber } from 'rxjs';
import { Microsoft360View } from '../models/generated/ziroModels';
import { Microsoft360ViewResource } from '../resources/microsoft-360-view.resource';
import { ActivatedRoute } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { MicrosoftTenantsStateContext } from './microsoft-tenants-state.context';

@Injectable()
export class Microsoft360ViewContext {
  private microsoft360ViewResource = inject(Microsoft360ViewResource);
  private route = inject(ActivatedRoute);
  private _tenantsStateContext = inject(MicrosoftTenantsStateContext);

  public _stateSource = new ReplaySubject<Microsoft360View>(1);
  public state$ = this._stateSource.asObservable();
  private _tenantId: string;

  constructor() {
    const userPrincipalName = this.route.snapshot.paramMap.get('upn');
    this._tenantsStateContext.cachedTenantState$
      .pipe(
        filter((cachedTenant) => !!cachedTenant?.tenantId),
        take(1),
      )
      .subscribe((cachedTenant) => {
        this._tenantId = cachedTenant.tenantId.toString();
        this.refresh(userPrincipalName).subscribe();
      });
  }

  refresh(userPrincipalName: string): Observable<Microsoft360View> {
    return new Observable<Microsoft360View>((subscriber: Subscriber<Microsoft360View>) => {
      this._getMicrosoft360View(userPrincipalName, this._tenantId).subscribe({
        next: (microsoft360View: Microsoft360View) => {
          this._stateSource.next(microsoft360View);
          subscriber.next(microsoft360View);
          subscriber.complete();
        },
        error: (response) => {
          if (response.status === 404) {
            window.location.href = `${window.location.origin}/app2/#/home`;
          }
          subscriber.error(response);
          subscriber.complete();
        },
      });
    });
  }

  setMicrosoft360View(ms360View: Microsoft360View): void {
    this._stateSource.next(ms360View);
  }

  private _getMicrosoft360View(userPrincipalName: string, tenantId: string): Observable<Microsoft360View> {
    return this.microsoft360ViewResource.get(userPrincipalName, tenantId);
  }
}
